import PropTypes from "prop-types";
import React from "react";
import TextStyles from "theme/components/text/TextStyles";

const H2 = ({ children }) => (
    <TextStyles
        as="h2"
        textStyles={["Myriad Pro/24-120-semibold", null, null, null, null, "Myriad Pro/32-120-semibold"]}
    >
        {children}
    </TextStyles>
);

H2.propTypes = {
    children: PropTypes.node.isRequired,
};

export default H2;
